import { axiosInstance } from '../base.api';
import { paths } from '../paths';
import { WarehouseMagamentType } from '../type/warehouse-management.type';

export const getAllWarehouseProducts = async (): Promise<WarehouseMagamentType> => {
  return axiosInstance.get(paths.warehouseManagement()).then(response => response.data.data);
};
